module.exports = __webpack_public_path__ + "static/media/speech_17.b805e550.svg";